import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogComponent } from './dialog.component';
import { DialogRoutingModule } from './dialog-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {DialogModule} from "../../component/ing/dialog/dialog";
import {TableModule} from "../../component/ing/table/table";
import {ButtonModule} from "../../component/ing/button/button";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    DialogModule,
    TableModule,
    ButtonModule
  ],
  declarations: [DialogComponent]
})
export class DialogDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/dialog/dialogDemo.module.ts